export default __webpack_public_path__ + "static/media/minecraft-animation.c3b5a266.jpg";